<template lang="html">
<div>
  <el-row>
    <el-col :span="21"><h4>收入汇总</h4></el-col>
    <el-col :span="3">
      <channel-select  ref="channelSelect" clearable filterable  @change="channelIdsChange" placeholder="展示渠道"></channel-select>
    </el-col>
  </el-row>
  <el-row :gutter="20">
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>累计收入金额</p>
        <p>{{statistics.allTotal/100}}元 / {{statistics.allCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>最近30天收入金额</p>
        <p> {{statistics.thirtyAllDayTotal/100}} 元 / {{statistics.thirtyAllDayCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>昨日收入金额</p>
        <p> {{statistics.yesterdayTotal/100}} 元 / {{statistics.yesterdayCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>今日收入金额</p>
        <p> {{statistics.todayTotal/100}} 元 / {{statistics.todayCount}} 笔</p>
      </el-card>
    </el-col>
  </el-row>

  <h4>车小花收入</h4>

  <el-row :gutter="20">
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>累计收入金额</p>
        <p> {{statistics.sxbTotal/100}} 元 / {{statistics.sxbCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>最近30天收入金额</p>
        <p> {{statistics.thirtyDaySxbTotal/100}} 元 / {{statistics.thirtyDaySxbCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>昨日收入金额</p>
        <p> {{statistics.yesterdaySxbTotal/100}} 元 / {{statistics.yesterdaySxbCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>今日收入金额</p>
        <p> {{statistics.todaySxbTotal/100}} 元 / {{statistics.todaySxbCount}} 笔</p>
      </el-card>
    </el-col>
  </el-row>
  <h4>渠道收入</h4>
  <el-row :gutter="20">
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>累计收入金额</p>
        <p> {{statistics.channelTotal/100}} 元 / {{statistics.channelCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>最近30天收入金额</p>
        <p> {{statistics.thirtyDayChannelTotal/100}} 元 / {{statistics.thirtyDayChannelCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>昨日收入金额</p>
        <p> {{statistics.yesterdayChannelTotal/100}} 元 / {{statistics.yesterdayChannelCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>今日收入金额</p>
        <p> {{statistics.todayChannelTotal/100}} 元 / {{statistics.todayChannelCount}} 笔</p>
      </el-card>
    </el-col>
  </el-row>
</div>
</template>

<script>
import channelSelect from '@/components/channelSelect'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'free-statistics',
  components: {
    channelSelect
  },
  data: function () {
    return {
      queryParams: {
        channelId: null
      },
      statistics: {
        allTotal: 0,
        allCount: 0,
        thirtyAllDayTotal: 0,
        thirtyAllDayTotal: 0,
        yesterdayTotal: 0,
        yesterdayCount: 0,
        todayTotal: 0,
        todayCount: 0,

        sxbTotal: 0,
        sxbCount: 0,
        thirtyDaySxbTotal: 0,
        sxbThirtyDaysCount: 0,
        yesterdaySxbTotal: 0,
        yesterdaySxbCount: 0,
        todaySxbTotal: 0,
        todaySxbCount: 0,

        channelTotal: 0,
        channelCount: 0,
        thirtyDayChannelTotal: 0,
        thirtyDayChannelCount: 0,
        yesterdayChannelTotal: 0,
        yesterdayChannelCount: 0,
        todayChannelTotal: 0,
        todayChannelCount: 0
      }
    }
  },
  created: function () {
    // let userInfo = JSON.parse(localStorage.userInfo)
    // this.isAdmin = userInfo.loginPath != 'channel'
    this.selectStatistics()
  },
  methods: {
    channelIdsChange: function (channelId) {
      if (channelId) {
        this.queryParams.channelId = channelId
      } else {
        this.queryParams.channelId = null
      }

      this.selectStatistics()
    },
    selectStatistics: function () {
      let _this = this
      let param = {}

      if (this.queryParams.channelId) {
        param.channelId = this.queryParams.channelId
      }

      let listener = {
        success: function (dataInfo) {
          _this.statistics = dataInfo.datas
        }
      }

      BasicModel.get(this, 'privateUsedCar/selectStatistics.action', param, listener)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
